import { Environment } from './environment.model';
import { APP_VERSION } from './version';

export const environment: Environment = {
  environment: 'dev',
  oktaGroupEnvironment: 'dev',
  appVersion: APP_VERSION,
  amplitude: { apiKey: '3000dd0f17ddf94a733911e2d29e43fc' },
  production: false,
  commandCenterEnvironment: 'svc',
  oktaClientId: '0oas1sanekp6u1uUo697',
  apiEndpoints: {
    'api-mobile': 'https://api-internal.dev.insidebrightside.com',
    'api-internal': 'https://api-internal.dev.insidebrightside.com',
    'brightnav-api': 'https://p80vp28gk8.execute-api.us-west-2.amazonaws.com',
    copilot: 'https://copilot.dev.insidebrightside.com/api/v1',
    'command-center':
      'https://command-center-api.svc.insidebrightside.com/api/v1',
    'conversational-btm':
      'https://conversational-btm-api.dev.insidebrightside.com/api/v1',
  },
  sentry: {
    dsn: 'https://9afb809b96d96ce273e52f7997dc6a0a@o4505166779187200.ingest.us.sentry.io/4509713674272768',
    environment: 'dev',
  },
  launchdarkly: { clientSideId: '69b2d950f74ec30a197f5b26' },
};
